module.exports = __webpack_public_path__ + "img/gzh.3a94d3cb.jpg";